import styled, { css } from 'styled-components';
import { sm } from '@exonet/react-shared/lib/styled';
import { hoverScale } from 'app/client/styled/animations';

export const Wrapper = styled.div`
  flex: 1 1 auto;
  align-self: stretch;
  display: flex;

  ${sm(css`
    position: relative;
  `)}
`;

export const Toggle = styled.button.attrs({
  type: 'button',
})`
  border: 0;
  background-color: transparent;
  flex: 1 1 var(--xs-header-height);
  align-self: stretch;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
  min-width: 50px;

  &:focus {
    outline: none;
  }

  ${sm(css`
    width: var(--lg-header-height);
  `)}
`;

export const Icon = styled.span`
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  ${hoverScale({
    hoverScaleValue: 1.25,
    activeScaleValue: 1.05,
    durationMs: 200,
    triggerSelector: Toggle,
    targetSelector: '&',
  })}
  > svg {
    color: var(--navbar-icon-color);
    fill: var(--navbar-icon-color);
    display: block;
  }
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TooltipDivider = styled.div`
  height: 1px;
  background: var(--search-row-hover-border);
  opacity: 0.8;
`;

export const FooterHint = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  color: var(--text-muted);
  font-size: var(--sm-font-size);
  white-space: nowrap;
`;

export const Keycap = styled.kbd`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  height: 22px;
  min-width: 22px;
  padding: 0 8px;

  border-radius: var(--border-radius);
  border: 1px solid var(--bg-3);
  background: var(--bg);

  color: var(--title-text);
  font-size: var(--xs-font-size);
  font-family: var(--font-family-2);

  box-shadow: none;
`;
